import { EntityZone } from '../../../../../core/models/configuration-system/entity-zone.model';

  export const entityZoneSpsa =  {
    searchText: 'Buscar zona de entidad',
    addText: '',
    export: false,
    filter: false,
    filterDefault: '',
    disabled: false,
    partialField: '',
    selectedRow: true,
    columns: [
      {
        title: 'Nombre de la zona',
        name: 'zoneName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: EntityZone) => element.zoneName
      },
      {
        title: 'Clientes por zona',
        name: 'clientsZone',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: EntityZone) => element.clientsZone
      },
      {
        title: 'Jerarquias',
        name: 'hierarchies',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: EntityZone) => element.hierarchies
      },
      {
        title: 'Picking agrupado',
        name: 'groupPicking',
        type: 'boolean',
        editable: true,
        checkAll: false,
        class: 'center',
        value: (element: EntityZone) => element.groupPicking
      },
      {
        title: 'Activo',
        name: 'enabled',
        type: 'boolean',
        editable: true,
        checkAll: false,
        class: 'left',
        value: (element: EntityZone) => element.enabled
      }
    ],
    subTable: {}
  };
